export const LANGUAGE_PREFERENCE_STORAGE_KEY = 'languagePreference';

const languageNameToI18nLanguage = {
    English: 'en-US',
    'French Canadian': 'fr-CA',
    French: 'fr',
    Korean: 'ko',
    Mandarin: 'zh-Hans',
    Spanish: 'es',
    Japanese: 'ja',
    German: 'de',
    Portuguese: 'pt',
    Hindi: 'hi',
    Polish: 'pl',
    Italian: 'it',
    Malay: 'ms',
    Dutch: 'nl',
};
export const getI18nLanguageByLanguageName = (locale?: string): string | undefined => {
    return locale && languageNameToI18nLanguage[locale];
};

export const getLanguageNameByI18nLanguage = (locale?: string): string | undefined => {
    return Object.keys(languageNameToI18nLanguage).find(
        key => languageNameToI18nLanguage[key] === locale,
    );
};

export const saveI18nLanguageToLocalStorage = (language: string) => {
    localStorage.setItem(LANGUAGE_PREFERENCE_STORAGE_KEY, language);

    return language;
};

export const clearI18nLanguageFromLocalStorage = () => {
    localStorage.removeItem(LANGUAGE_PREFERENCE_STORAGE_KEY);
};

export const getI18nLanguageFromLocalStorage = () => {
    return localStorage.getItem(LANGUAGE_PREFERENCE_STORAGE_KEY);
};

export const getI18nLanguageFromLocalStorageOrDefaultI18nLanguage = () => {
    let i18nLanguage = getI18nLanguageFromLocalStorage();

    return i18nLanguage ?? 'en-US';
};
